<template>
  <div class="container page lottery">
    <!-- 数据未就绪时盖住整页，避免 00:00:00 / 空骰子等默认态闪现 -->
    <div v-if="!pageReady" class="lottery-boot-loading">
      <img src="/img/game1.jpg" alt="" />
      <span class="loader2"></span>
    </div>
    <template v-if="pageReady">
    <van-nav-bar :title="lottery.name" class="nav-bar" :border="false">
      <template #left>
        <van-icon name="arrow-left" @click="back()" />
      </template>
      <template #right>
        <div class="nav-task-record" @click="$router.push('/GameRecord')">
          <van-icon name="more-o" />
          <span>{{ $t('my.task_record') }}</span>
        </div>
      </template>
    </van-nav-bar>
    <div class="record">
      <div class="period">
        <span class="period-number">{{ lottery.next_expect }}</span>
        <div class="next-number">
          <van-count-down :time="time" @finish="check()" />
        </div>
      </div>
      <div
        class="linear-gradient"
        style="background: linear-gradient(to right, rgba(126, 86, 120, 0), rgb(230, 195, 161), rgba(126, 86, 120, 0))"
      ></div>
      <div class="recent" @click="toggleHistory">
        <div class="recent-result">
          <span class="res-label">{{ sizeWord }} {{ doubleWord }}</span>
        </div>
        <div class="history-arrow">
          <van-icon
            name="arrow-down"
            :class="{ up: active }"
          />
        </div>
      </div>
      <div v-show="active" class="history-dropdown">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <div class="history-list">
            <div class="item item-head">
              <div class="left font-weight">{{ $t("reservation.num") }}</div>
              <div class="right font-weight">{{ $t("reservation.win_num") }}</div>
            </div>
            <div class="item" v-for="(v, key) in lottery_list" :key="key">
              <div class="left font-weight">{{ v.expect }}</div>
              <div class="right">
                <div class="kuaisan-ball">
                  <span class="res-des middle res-label">{{
                    getHistorySizeWord(v.opencode[0], v.opencode[1], v.opencode[2])
                  }} {{
                    getHistoryDoubleWord(v.opencode[0], v.opencode[1], v.opencode[2])
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </van-pull-refresh>
      </div>
    </div>
    <div class="wrapper">
      <div class="options-bar">
        <div class="game">
          <div class="game-body">
          <div class="sumValueTwoSides">
            <div
              class="rectangle large"
              :class="{ active: isOptionActive(v) }"
              v-for="(v, key) in lottery_peilv_list"
              :key="key"
              @click="choosePlay(v.type, v.name)"
            >
              <div class="opt-card">
                <van-icon
                  v-if="isOptionActive(v)"
                  class="opt-check"
                  name="success"
                  color="#ffffff"
                />
                <img class="opt-img" :src="getOptionImg(v, key)" alt="" />
                <p class="name-text">{{ getOptionName(v) }}</p>
              </div>
            </div>
          </div>

          <div class="activityGroup">
            <div class="activityTitleWrap">
              <span class="ac-title">{{ $t('game.live_broadcast') }}</span>
            </div>
            <div class="box1">
              <div class="chatList" :style="broadcastAnimStyle">
                <div
                  class="profitCont"
                  v-for="(row, idx) in broadcastLoopList"
                  :key="'b-' + idx"
                >
                  <div class="Cont_item_top">
                    <div class="item_top_right">{{ row }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
      <div class="bottom-bar">
        <div class="bet-panel" :class="{ active: shopping || formData.length > 0 }">
          <div class="item">
            <span class="label">{{ $t('reservation.curr_choose') }}：</span>
            <div class="bet-number">{{ convertedShopchoose }}</div>
            <van-icon
              name="arrow-down"
              :class="{ up: !(shopping || formData.length > 0), down: shopping || formData.length > 0 }"
              @click="shopping = !shopping"
            />
          </div>
          <div class="item">
            <span class="label">{{ $t('reservation.per_price') }}</span>
            <div class="amount-wrapper">
              <van-field
                v-model="money"
                type="digit"
                :placeholder="$t('reservation.price_place')"
              />
              <span class="label">{{ $t('reservation.unit') }}</span>
            </div>
          </div>
          <div class="item summary-row">
            <div class="part">
              <span>{{ $t('reservation.total') }}</span>
              <span class="number">{{ formData.length }}</span>
              <span>{{ $t('reservation.note') }}</span>
            </div>
            <div class="part">
              <span>{{ $t('reservation.total') }}</span>
              <span class="number">{{ formData.length * money || 0 }}</span>
              <span>{{ $t('reservation.unit') }}</span>
            </div>
          </div>
          <button type="button" class="vote-btn" @click="jiesuan()">
            {{ $t('reservation.vote') }}
          </button>
        </div>
      </div>
    </div>
    <van-popup v-model="jiesuanpage" get-container="body">
        <div class="confirm-order-modal">
          <!-- <div class="head van-hairline--bottom">
            <p class="text">{{ $t("reservation.task_list") }}</p>
          </div> -->
          <ui class="list">
            <li v-for="(v, key) in formData" :key="key" class="lise-item van-hairline--bottom">
              <div class="main">
                <p class="bet-name">{{ getOptionName(v) }}</p>
                <p class="detail-text">
                  1{{ $t("reservation.note") }}X{{ money
                  }}{{ $t("reservation.unit") }}={{ money
                  }}{{ $t("reservation.ge") }}
                </p>
              </div>
              <van-icon @click="clearChooes(v.type)" name="close" />
            </li>
          </ui>
          <div class="sub-bar">
            <van-button class="item cancel-btn" type="default" @click="allClear()">
              {{ $t('reservation.clear_order') }}
            </van-button>
            <van-button class="item sub-btn" type="default" @click="doSub">
              {{ $t('reservation.submit') }}
            </van-button>
          </div>
        </div>
      </van-popup>
    <van-popup v-model="showModel" position="right" :style="{ width: '70%', height: '100%' }">
      <div class="list">

        <div class="item" v-for="(i, index) in gameitemData" :key="index" @click="tabList(i.id, i.key)">
          <div>{{$t("q29")}}</div>
          <div style="margin: 15px 0 0 15px;">
            <div
              style="height: 86px;background-color: #fff;width: 60px;display: flex;align-items: center;border-radius: 8px;">
              <van-image width="60" height="61" :src="i.ico" style="" />
            </div>

            <div style="font-size: 14px;">{{ i.name }}</div>
          </div>
        </div>


      </div>
    </van-popup>
    </template>
  </div>
</template>

<script>
var time;
var count = 0;
import { normalizeBetType } from '@/utils/gameBet'
import { getStoredLang } from '@/utils/lang'

export default {
  data() {
    return {
      jiesuanpage: false,
      showModel: false,
      rose: '',
      lily: '',
      balloon: "",
      fireworks: "",
      choose: {
        big: false,
        small: false,
        one: false,
        two: false,
        甲: false,
        乙: false,
        丙: false,
        丁: false,
        "3": false,
        "4": false,
        "5": false,
        "6": false,
        "7": false,
        "8": false,
        "9": false,
        "10": false,
        "11": false,
        "12": false,
        "13": false,
        "14": false,
        "15": false,
        "16": false,
        "17": false,
        "18": false,
      },
      playgame: false,
      shopping: false,
      isLoading: false,
      play: {},
      lottery_peilv_list: [],
      lottery_list: {},
      active: false,
      userInfo: {},
      lottery: {},
      shanzi_1: "",
      shanzi_2: "",
      shanzi_3: "",
      openCodes: ["", "", ""],
      sum: "",
      size: "",
      double: "",
      time: 0,
      shopchoose: this.$t("reservation.no_choose"),
      gameitem: "",
      formData: [],
      money: "20",
      ids: 11,
      keys: 5,
      gameitemData: [],
      userTimer:"",
      coverError: false,
      pageReady: false,
      listData: [],
    };
  },
  watch: {
    '$route.query': {
      handler(query) {
        if (this.$route.name !== 'Lottery') return
        if (this.applyRouteQuery(query)) {
          this.reloadLotteryData()
        }
      },
      deep: true,
    },
  },
  mounted(){
    if(this.userTimer){
      clearInterval(this.userTimer);
      this.userTimer = ""
    }
    setInterval(()=>{
      this.getUserInfo()
    },10000)
   
  },
  methods: {
    applyRouteQuery(query = this.$route.query) {
      let changed = false
      if (query.key !== undefined && query.key !== null && query.key !== '') {
        const nextKey = query.key
        if (String(this.keys) !== String(nextKey)) {
          this.keys = nextKey
          changed = true
        }
      }
      if (query.id !== undefined && query.id !== null && query.id !== '') {
        const nextId = Number(query.id)
        if (this.ids !== nextId) {
          this.ids = nextId
          changed = true
        }
      }
      return changed
    },
    reloadLotteryData() {
      this.allClear()
      this.bootstrapPage(true)
    },
    /** 首屏/切换彩种：先拿用户信息再并行拉彩种数据，完成后再露出页面 */
    bootstrapPage(showBootLoading = true) {
      if (showBootLoading) this.pageReady = false
      this.applyRouteQuery()
      return this.fetchUserInfo()
        .then(() =>
          Promise.all([
            this.fetchLotteryInfo(),
            this.fetchLotteryListAndPeilv(),
            this.fetchGameItem(),
          ])
        )
        .catch(() => {})
        .finally(() => {
          this.pageReady = true
        })
    },
    fetchUserInfo() {
      return this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          if (this.userInfo.is_online != 1) {
            localStorage.clear()
            this.$router.push({ path: '/Login' });
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
        return res
      });
    },
    fetchLotteryPeilv() {
      return this.$http({
        method: "get",
        data: { id: this.ids },
        url: "lottery_get_peilv",
      }).then((res) => {
        if (res.code === 200) {
          let lottery_peilv_list = res.data || [];
          // 只展示甲乙丙丁四项玩法
          const mainTypes = new Set(['big', 'small', 'one', 'two', 'bi', 'sm', 'si', 'do', 'BESAR', 'KECIL', 'GANJIL', 'GENAP', '甲', '乙', '丙', '丁'])
          lottery_peilv_list = lottery_peilv_list.filter((item) => mainTypes.has(item.type) || mainTypes.has(item.name))
          if (!lottery_peilv_list.length) {
            lottery_peilv_list = (res.data || []).slice(0, 4)
          }
          this.lottery_peilv_list = lottery_peilv_list.map((itemc, idx) => ({
            ...itemc,
            img: itemc.img || this.getOptionImg(itemc, idx),
          }));
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
        return res
      });
    },
    fetchLotteryListAndPeilv() {
      return this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_one_list",
      }).then((res) => {
        if (res.code === 200) {
          this.lottery_list = res.data;
          this.syncOpenCodeFromHistory();
          return this.fetchLotteryPeilv();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
        return res
      });
    },
    fetchGameItem() {
      return this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res => {
        this.gameitemData = res.data;
        return res
      })
    },
    fetchLotteryInfo() {
      return this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_info",
      }).then((res) => {
        if (res.code === 200) {
          if (
            this.userInfo &&
            this.userInfo.money != null &&
            parseFloat(this.userInfo.money) < parseFloat(res.data.condition)
          ) {
            this.$toast(this.$t("reservation.contact_admin"));
            this.$router.push({ path: "/Home" });
            return res;
          }
          this.lottery = res.data;
          this.coverError = false;
          this.time = res.data.second * 1000;

          if (this.time / 1000 === 59) {
            this.$toast(
              this.$t("reservation.prize_succ") + this.lottery.now_expect
            );
          }

          this.applyOpenCode(res.data.opencode)
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
        return res
      });
    },
    /** 解析开奖号码并填充左上角三格 + 甲乙丙丁结果 */
    applyOpenCode(raw) {
      const codes = this.normalizeOpenCode(raw)
      if (!codes) return false
      this.openCodes = codes.slice()
      this.shanzi_1 = String(codes[0])
      this.shanzi_2 = String(codes[1])
      this.shanzi_3 = String(codes[2])
      this.sum = codes[0] + codes[1] + codes[2]
      if (this.sum >= 11 && this.sum <= 18) {
        this.size = '甲'
      } else if (this.sum >= 3 && this.sum <= 10) {
        this.size = '乙'
      } else {
        this.size = ''
      }
      if (this.sum % 2 === 0) {
        this.double = '丁'
      } else {
        this.double = '丙'
      }
      return true
    },
    normalizeOpenCode(raw) {
      if (raw == null || raw === '') return null
      let arr = raw
      if (typeof raw === 'string') {
        arr = raw.split(/[,|，\s]+/).filter((v) => v !== '')
      }
      if (!Array.isArray(arr) || arr.length < 3) return null
      const codes = [parseInt(arr[0], 10), parseInt(arr[1], 10), parseInt(arr[2], 10)]
      if (codes.some((n) => Number.isNaN(n))) return null
      return codes
    },
    /** 当期没有开奖号码时，用历史最近一期补齐左上角 */
    syncOpenCodeFromHistory() {
      if (this.openCodes && this.openCodes[0] !== '' && this.openCodes[0] != null) return
      const list = this.lottery_list
      let latest = null
      if (Array.isArray(list) && list.length) {
        latest = list[0]
      } else if (list && typeof list === 'object') {
        const values = Object.keys(list)
          .sort((a, b) => Number(a) - Number(b))
          .map((k) => list[k])
        latest = values[0]
      }
      if (latest && latest.opencode) {
        this.applyOpenCode(latest.opencode)
      }
    },
    toMine() {
      this.$router.push("/Mine")
    },
    back() {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.replace({ path: '/Home' })
      }
    },
    toggleHistory() {
      this.active = !this.active
    },
    mediaUrl(url) {
      if (!url) return ''
      if (/^https?:\/\//i.test(url)) return url
      const base = process.env.NODE_ENV === 'development' ? '' : 'https://api.t9299.top'
      if (url.startsWith('/')) return `${base}${url}`
      return `${base}/${url}`
    },
    onCoverError() {
      this.coverError = true
    },
    /** 演示站同款：按彩种 id + 序号取图，本地已采集到 /img/lottery/opts */
    getOptionImg(item, index) {
      if (item && item.img) return this.mediaUrl(item.img)
      const typeMap = {
        big: 1, bi: 1, BESAR: 1, 甲: 1,
        small: 2, sm: 2, KECIL: 2, 乙: 2,
        one: 3, si: 3, GANJIL: 3, 丙: 3,
        two: 4, do: 4, GENAP: 4, 丁: 4,
      }
      const n = typeMap[item && item.type] || typeMap[item && item.name] || (Number(index) + 1)
      return `/img/lottery/opts/${n}.jpg`
    },
    loadBroadcastList() {
      // 参考站 base_info.winners 同款英文滚动文案
      this.listData = [
        'Congratulations on completing the first voting round A*7X9',
        'Congratulations on completing the second voting round B****3L4',
        'Congratulations on completing the first voting round C****8M2',
        'Congratulations on completing the second voting round D****5N6',
        'Congratulations on completing the first voting round E****1P8',
        'Congratulations on completing the second voting round F****9Q3',
        'Congratulations on completing the first voting round G****2R7',
        'Congratulations on completing the second voting round H****4S5',
        'Congratulations on completing the first voting round I****6T1',
        'Congratulations on completing the second voting round J****8U4',
        'Congratulations on completing the first voting round K****3V9',
        'Congratulations on completing the second voting round L****7W2',
        'Congratulations on completing the first voting round M****5X6',
        'Congratulations on completing the second voting round N****1Y8',
        'Congratulations on completing the first voting round O****9Z3',
        'Congratulations on completing the second voting round P****2A7',
        'Congratulations on completing the first voting round Q****4B5',
        'Congratulations on completing the second voting round R****6C1',
        'Congratulations on completing the first voting round S****8D4',
        'Congratulations on completing the second voting round T****3E9',
      ]
    },
    getOptionKeys(type, name) {
      const canonical = normalizeBetType(type) || normalizeBetType(name)
      const map = {
        big: '甲',
        small: '乙',
        one: '丙',
        two: '丁',
        甲: 'big',
        乙: 'small',
        丙: 'one',
        丁: 'two',
      }
      const keys = new Set([type, name, canonical, map[canonical], map[type], map[name]].filter(Boolean))
      return [...keys]
    },
    syncSelectedItems() {
      if (this.formData.length === 0) {
        this.shopchoose = this.$t('reservation.no_choose')
        this.gameitem = ''
        this.shopping = false
        return
      }
      this.shopchoose = this.formData.map((item) => item.name).join(',')
      this.gameitem = this.formData.map((item) => normalizeBetType(item.type)).join(',')
      if (this.formData.length === 1) {
        this.shopping = true
      }
    },
    isOptionActive(v) {
      return this.getOptionKeys(v.type, v.name).some((key) => this.choose[key])
    },
    doSub() {
      if (this.money === "0") {
        this.$toast(this.$t("reservation.money_err"));
        return false;
      }
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        if (this.userInfo.money - this.money * this.formData.length < 0) {
          this.$toast(this.$t("reservation.balance_enough"));
          return false;
        } else {
          this.$http({
            method: "post",
            data: {
              item: this.gameitem,
              money: this.money,
              lid: this.lottery.id,
              mid: this.userInfo.id,
              expect: this.lottery.now_expect,
            },
            url: "game_place_order",
          }).then((res) => {
            if (res.code === 200) {
              this.$toast(res.msg);
              this.allClear();
              this.getUserInfo();
            } else if (res.code === 401) {
              this.$toast(res.msg);
            }
          });
          return true;
        }
      }
    },
    allClear() {
      Object.keys(this.choose).forEach((key) => {
        this.choose[key] = false
      })
      this.formData.length = 0;
      this.money = "";
      this.shopchoose = this.$t("reservation.no_choose");
      this.gameitem = "";
      this.shopping = false;
      this.jiesuanpage = false;
    },
    showRight() {
      this.showModel = true;
    },
    jiesuan() {
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        this.jiesuanpage
          ? (this.jiesuanpage = false)
          : (this.jiesuanpage = true);
      }
    },
    clearChooes(type) {
      const targetType = normalizeBetType(type)
      for (let i = this.formData.length - 1; i >= 0; i--) {
        if (targetType === normalizeBetType(this.formData[i].type)) {
          this.getOptionKeys(this.formData[i].type, this.formData[i].name).forEach((key) => {
            this.choose[key] = false
          })
          this.formData.splice(i, 1)
        }
      }
      this.syncSelectedItems()
      if (this.formData.length === 0) {
        this.jiesuanpage = false
      }
    },
    choosePlay(type, name) {
      const canonicalType = normalizeBetType(type) || normalizeBetType(name)
      const keys = this.getOptionKeys(type, name)
      const isActive = keys.some((key) => this.choose[key])
      if (isActive) {
        keys.forEach((key) => {
          this.choose[key] = false
        })
        for (let i = this.formData.length - 1; i >= 0; i--) {
          if (canonicalType === normalizeBetType(this.formData[i].type)) {
            this.formData.splice(i, 1)
          }
        }
      } else {
        this.formData.push({ name, type: canonicalType })
        keys.forEach((key) => {
          this.choose[key] = true
        })
      }
      this.syncSelectedItems()
    },
    check() {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        time = window.setInterval(() => {
          setTimeout(() => {
            this.getUserInfo();
            this.getLotteryInfo();
            this.getLotteryList();
            count++;
            if (count > 5) {
              clearInterval(time);
              count = 0;
            }
          }, 0);
        }, 300);
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.getLotteryList();
        this.isLoading = false;
      }, 200);
    },
    getUserInfo() {
      return this.fetchUserInfo();
    },
    getLotteryPeilv() {
      return this.fetchLotteryPeilv();
    },
    getLotteryList() {
      return this.fetchLotteryListAndPeilv();
    },
    getGameItem() {
      return this.fetchGameItem();
    },
    tabList(id, key) {
      this.ids = id
      this.keys = key
      this.showModel = false
      this.bootstrapPage(true)
    },
    getLotteryInfo() {
      return this.fetchLotteryInfo();
    },
    getOptionName(v) {
      const labels = {
        big: 'Modell',
        small: 'Schwester',
        one: 'Sekretär',
        two: 'Schüler',
        bi: 'Modell',
        sm: 'Schwester',
        si: 'Sekretär',
        do: 'Schüler',
        BESAR: 'Modell',
        KECIL: 'Schwester',
        GANJIL: 'Sekretär',
        GENAP: 'Schüler',
        甲: 'Modell',
        乙: 'Schwester',
        丙: 'Sekretär',
        丁: 'Schüler',
      }
      const canonical = normalizeBetType(v.type) || normalizeBetType(v.name)
      return labels[canonical] || labels[v.name] || labels[v.type] || v.name
    },
    getDiceImg(num) {
      return `/img/lottery/shaizi/${num}.png`;
    },
    getHistorySizeLabel(n1, n2, n3) {
      const zhi = n1 + n2 + n3;
      return zhi >= 11 && zhi <= 18 ? '甲' : '乙';
    },
    getHistoryDoubleLabel(n1, n2, n3) {
      const zhi = n1 + n2 + n3;
      return zhi % 2 === 0 ? '丁' : '丙';
    },
    getHistorySizeWord(n1, n2, n3) {
      return this.getHistorySizeLabel(n1, n2, n3) === '甲' ? 'Modell' : 'Schwester'
    },
    getHistoryDoubleWord(n1, n2, n3) {
      return this.getHistoryDoubleLabel(n1, n2, n3) === '丁' ? 'Schüler' : 'Sekretär'
    },
    calcBg(el) {
      if (el == '甲' || el == '玫瑰' || el == 'Rose' || el == 'ロケット' || el == '장미') {
        return 'd'
      } else
        if (el == '乙' || el == '百合' || el == 'Lily' || el == "ハート" || el == '백합') {
          return 'x'
        } else
          if (el == '丙' || el == "煙花" || el == "fireworks" || el == "ヨット" || el == "불꽃놀이") {
            return 'v'
          } else
            if (el == '丁' || el == "氣球" || el == "Balloon" || el == "バラ" || el == "풍선") {
              return 'r'
            } else {
              return 'r'
            }
    },
    calcBgLs(n1, n2, n3, type) {
      let zhi = n1 + n2 + n3;
      if (type == 'type1') {
        if (zhi >= 11 && zhi < 18) {
          return 'd'
        } else {
          return 'x'
        }
      }
      if (type == 'type2') {
        if (zhi % 2 == 0) {
          return 'v'
        } else {
          return 'r'
        }
      }
    }
  },

  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
      return
    }
    this.loadBroadcastList()
    this.bootstrapPage(true)
    const lang = getStoredLang();
    if (lang == 'zh') {
      this.rose = '玫瑰';
      this.lily = '百合';
      this.balloon = '氣球'
      this.fireworks = '煙花'
    } else if (lang == 'de') {
      this.rose = 'Rose';
      this.lily = 'Lilie';
      this.balloon = 'Ballon'
      this.fireworks = 'Feuerwerk'
    } else if (lang == 'fr') {
      this.rose = 'Rose';
      this.lily = 'Lys';
      this.balloon = 'Ballon'
      this.fireworks = "Feu d'artifice"
    } else if (lang == 'it') {
      this.rose = 'Rosa';
      this.lily = 'Giglio';
      this.balloon = 'Palloncino'
      this.fireworks = "Fuochi d'artificio"
    } else {
      this.rose = 'Rose';
      this.lily = 'Lily';
      this.balloon = 'Balloon'
      this.fireworks = 'Fireworks'
    }

  },
  computed: {
    broadcastLoopList() {
      const list = this.listData || []
      if (!list.length) return []
      // 复制一份做无缝循环
      return list.concat(list)
    },
    broadcastAnimStyle() {
      const n = (this.listData && this.listData.length) || 0
      const duration = Math.max(12, n * 1.6)
      return {
        animationDuration: `${duration}s`,
      }
    },
    sizeWord() {
      if (this.size === '甲') return 'Modell'
      if (this.size === '乙') return 'Schwester'
      return this.size || ''
    },
    doubleWord() {
      if (this.double === '丙') return 'Sekretär'
      if (this.double === '丁') return 'Schüler'
      return this.double || ''
    },
    convertedShopchoose() {
      const mapping = {
        big: 'Modell',
        small: 'Schwester',
        one: 'Sekretär',
        two: 'Schüler',
        甲: 'Modell',
        乙: 'Schwester',
        丙: 'Sekretär',
        丁: 'Schüler',
      };

      return this.shopchoose.split(',').map(keyword => mapping[keyword] || keyword).join(',');
    },
    coverUrl() {
      if (this.coverError || !this.lottery.ico) {
        return '/img/neww/userpic.png'
      }
      return this.mediaUrl(this.lottery.ico)
    }
  },
  destroyed() {
    clearInterval(time);
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.lottery {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f2f2f5;
  overflow: hidden;
}

.nav-task-record {
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 26px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
}

.nav-task-record .van-icon {
  font-size: 32px;
  margin-right: 6px;
  color: #fff;
}

.lottery-boot-loading {
  position: fixed;
  inset: 0;
  background: #fea4a6;
  z-index: 3000;

  img {
    position: absolute;
    width: 150%;
    left: 0;
    top: 0;
    height: 100%;
    object-fit: cover;
    opacity: 0.85;
  }

  .loader2 {
    transform: rotate(45deg);
    perspective: 250px;
    border-radius: 50%;
    width: 62px;
    height: 62px;
    color: #fff;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  .loader2:before,
  .loader2:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: inherit;
    height: inherit;
    border-radius: 50%;
    transform: rotateX(70deg);
    animation: lottery-boot-spin 1s linear infinite;
  }

  .loader2:after {
    transform: rotateY(70deg);
    animation-delay: 0.4s;
  }
}

@keyframes lottery-boot-spin {
  0%,
  100% {
    box-shadow: 0.2em 0 0 0 currentcolor;
  }
  12% {
    box-shadow: 0.2em 0.2em 0 0 currentcolor;
  }
  25% {
    box-shadow: 0 0.2em 0 0 currentcolor;
  }
  37% {
    box-shadow: -0.2em 0.2em 0 0 currentcolor;
  }
  50% {
    box-shadow: -0.2em 0 0 0 currentcolor;
  }
  62% {
    box-shadow: -0.2em -0.2em 0 0 currentcolor;
  }
  75% {
    box-shadow: 0 -0.2em 0 0 currentcolor;
  }
  87% {
    box-shadow: 0.2em -0.2em 0 0 currentcolor;
  }
}

.record {
  padding: 0 20px;
  background-color: #fff;
  box-shadow: 0 2px 2px 0 #cacaca;
  z-index: 3;
  flex-shrink: 0;
  position: relative;
}

.record .period {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
}

.record .period .period-number {
  flex: 1;
  margin: 0;
  height: 50px;
  line-height: 50px;
  font-size: 35px;
  font-weight: 700;
  color: #000;
}

.next-number {
  text-align: right;
  flex-shrink: 0;
}

.van-count-down {
  color: #ff253f;
  font-size: 45px;
  margin-top: 10px;
}

.linear-gradient {
  width: 100%;
  height: 2px;
}

.record .recent {
  display: flex;
  align-items: center;
  height: 110px;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  background: #fff;
  cursor: pointer;
}

.recent-result {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-width: 0;
  padding: 0;
  box-sizing: border-box;
}

.recent-result .res-label {
  font-weight: 700;
  font-size: 32px;
  color: #ff7186;
  text-align: left;
  line-height: 1.2;
  white-space: nowrap;
}

.history-arrow {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  color: #999;
  font-size: 28px;
}

.history-dropdown {
  max-height: 50vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background: #fff;
  border-top: 1px solid #f0f0f0;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
}

.kuaisan-ball {
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball.left {
  justify-content: flex-start;
}

.kuaisan-ball .res-img {
  width: 70px;
  height: 70px;
  margin-right: 20px;
  flex-shrink: 0;
}

.kuaisan-ball .res-des {
  font-weight: 700;
  text-align: center;
  color: #000;
}

.kuaisan-ball .res-des.middle {
  min-width: 40px;
  font-size: 30px;
  margin-right: 16px;
}

.van-icon {
  font-size: 40px;
  color: #999;
}

.up {
  transform: rotate(180deg);
  transition: transform 0.3s;
}

.wrapper {
  position: relative;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.options-bar {
  display: flex;
  align-items: stretch;
  flex: 1;
  min-height: 0;
}

.options-bar .game {
  position: relative;
  flex: 1;
  width: 100%;
  min-height: 0;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #f7f8fa;
}

.game-body {
  position: relative;
  z-index: 1;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.sumValueTwoSides {
  display: flex;
  padding: 20px 0 10px;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  box-sizing: border-box;
  background: #fff;
}

.rectangle {
  overflow: hidden;
}

.rectangle.large {
  margin: 0 0 20px 4%;
  width: 44%;
  border-radius: 10px;
  box-shadow: 0 0 8px 0 #e4e4e7;
  background: #fff;
  box-sizing: border-box;
}

.opt-card {
  position: relative;
  text-align: center;
  padding: 12px 12px 16px;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-sizing: border-box;
}

.opt-check {
  position: absolute;
  top: 42%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  font-size: 48px !important;
}

.opt-img {
  display: block;
  width: 70%;
  aspect-ratio: 1 / 1;
  height: auto;
  object-fit: cover;
  margin: 0 auto;
  border-radius: 6px;
  background: #f2f2f5;
}

.name-text {
  margin: 14px 0 0;
  text-align: center;
  font-size: 28px;
  font-weight: 500;
  color: #3d3a5c;
  line-height: 1.2;
}

.rectangle.active {
  box-shadow: 0 0 0 2px #ff7186;
}

.rectangle.active .opt-card {
  background: #ffe8ec;
}

.rectangle.active .name-text {
  color: #ff556e;
}

.activityGroup {
  border-radius: 20px;
  margin: 10px 20px 24px;
  border: 2px solid #ff7186;
  padding-bottom: 10px;
  background: #fff;
  flex-shrink: 0;
}

.activityTitleWrap {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ff7186;
  padding: 36.5px 16px;
  min-height: auto;
  box-sizing: border-box;
  color: #fff;
  border-radius: 18px 18px 0 0;
}

.activityTitleWrap .ac-title {
  color: #fff;
  font-size: 28px;
  margin: 0;
  font-weight: 700;
  text-align: center;
  line-height: 1.2;
}

.box1 {
  max-height: 520px;
  min-height: 280px;
  padding: 12px 0;
  border-radius: 10px;
  overflow: hidden;
}

.chatList {
  animation-name: broadcast-scroll;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

.profitCont .Cont_item_top {
  padding: 18px 20px;
}

.profitCont:nth-child(2n) .Cont_item_top {
  background: #f0f0f0;
}

.profitCont .item_top_right {
  font-size: 24px;
  color: #666;
  line-height: 1.5;
}

@keyframes broadcast-scroll {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-50%);
  }
}

.bottom-bar {
  position: relative;
  flex-shrink: 0;
  z-index: 20;
  background: #fff;
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.06);
}

.bottom-bar .bet-panel {
  display: none;
  padding: 28px 20px 32px;
  background-color: #fff;
}

.bottom-bar .bet-panel.active {
  display: block;
}

.bottom-bar .bet-panel .item {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 56px;
  margin-bottom: 12px;
}

.bottom-bar .bet-panel .item .label {
  flex-shrink: 0;
  font-size: 0.9375rem;
  color: #666;
}

.bottom-bar .bet-panel .item .bet-number {
  flex: 1;
  margin: 0 10px;
  font-size: 0.9375rem;
  color: #e91e63;
  overflow: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}

.bottom-bar .bet-panel .item .amount-wrapper {
  flex: 1;
  display: flex;
  align-items: center;
  margin-left: 10px;
  min-width: 0;
}

.bottom-bar .bet-panel .item .part {
  display: flex;
  align-items: center;
  margin-right: 18px;
}

.bottom-bar .bet-panel .item .part span {
  font-size: 0.9375rem;
  color: #666;
}

.bottom-bar .bet-panel .item .part .number {
  margin: 0 6px;
  color: #e91e63;
  font-weight: 600;
}

.bottom-bar .bet-panel .summary-row {
  margin-top: 8px;
  margin-bottom: 8px;
}

.bottom-bar .vote-btn {
  display: block;
  width: 80%;
  margin: 20px auto 0;
  height: 78.5px;
  line-height: 78.5px;
  text-align: center;
  color: #fff;
  font-size: 1.125rem;
  font-weight: 600;
  border: none;
  border-radius: 28px;
  background: linear-gradient(20deg, #8673e5, #d958a4);
  cursor: pointer;
  user-select: none;
  -webkit-appearance: none;
  appearance: none;
}

.bottom-bar .vote-btn:active {
  opacity: 0.9;
}

::v-deep .bottom-bar .van-field__control {
  color: #333;
  font-size: 0.9375rem;
}

::v-deep .bottom-bar .van-cell {
  font-size: 0.9375rem;
  line-height: 1.5;
  padding: 12px 16px;
  min-height: 48px;
  background-color: #f8f8f8;
  margin-left: 8px;
  border-radius: 10px;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000;
  font-size: 35px;
}

::v-deep .van-popup {
  position: absolute;
}

::v-deep .van-overlay {
  position: absolute;
  background-color: rgba(70, 67, 67, 0.7);
}

.history-list {
  background: #fff;
  padding: 0 20px 20px;
}

.history-list .item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #f0f0f0;
}

.history-list .item-head {
  padding: 20px 0 12px;
  border-bottom: 1px solid #e8e8e8;
}

.history-list .item .left {
  width: 40%;
  font-size: 28px;
  text-align: center;
  color: #000;
  flex-shrink: 0;
}

.history-list .item .right {
  flex: 1;
  display: flex;
  justify-content: center;
  overflow: hidden;
  color: #000;
}

.history-list .item .kuaisan-ball {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: nowrap;
  gap: 16px;
  width: 100%;
  padding-right: 8px;
  box-sizing: border-box;
}

.history-list .item .kuaisan-ball .res-des {
  font-weight: 700;
  text-align: right;
  color: #ff7186;
  flex-shrink: 0;
}

.history-list .item .kuaisan-ball .res-des.middle,
.history-list .item .kuaisan-ball .res-label {
  min-width: 0;
  font-size: 28px;
  margin-right: 0;
  color: #ff7186;
}

.font-weight {
  font-weight: 700 !important;
}

.confirm-order-modal {
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 0 20px 30px;
  width: 610px;
  height: 680px;
  max-height: 50%;
  z-index: 10;
  background-color: #fff;
  border-radius: 30px;
}

.confirm-order-modal .head .text {
  padding: 20px;
  text-align: center;
  font-size: 35px;
  font-weight: 500;
  color: #7e5678;
}

.confirm-order-modal .list {
  flex: 1;
  padding: 0 10px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.confirm-order-modal .list .lise-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0;
  color: #ff253f;
}

.confirm-order-modal .list .lise-item .main {
  flex: 1;
  overflow: hidden;
}

.confirm-order-modal .list .lise-item .main .bet-name {
  color: #ff253f;
  font-size: 35px;
  font-weight: 500;
}

.confirm-order-modal .list .lise-item .main .detail-text {
  font-size: 25px;
  color: #979799;
}

.confirm-order-modal .sub-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding-top: 20px;
  flex-shrink: 0;
}

.confirm-order-modal .sub-bar .item {
  flex: 1;
  min-width: 0;
  height: 80px;
  margin: 0;
  padding: 0;
  text-align: center;
  box-sizing: border-box;
  border-radius: 50px;
  font-size: 35px;
  font-weight: 500;
}

::v-deep .confirm-order-modal .sub-bar .van-button {
  width: 100%;
  height: 80px;
  min-height: 80px;
  line-height: 1;
  padding: 0 16px;
  margin: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  font-size: 35px;
  font-weight: 500;
  box-sizing: border-box;
  vertical-align: middle;
}

::v-deep .confirm-order-modal .sub-bar .van-button__content {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  line-height: 1;
}

.confirm-order-modal .sub-bar .item.cancel-btn,
::v-deep .confirm-order-modal .sub-bar .cancel-btn.van-button {
  border: 2px solid #979799;
  color: #979799;
  background-color: #fff;
}

.confirm-order-modal .sub-bar .item.sub-btn,
::v-deep .confirm-order-modal .sub-bar .sub-btn.van-button {
  background: linear-gradient(20deg, #8673e5, #d958a4);
  color: #fff;
  border: 2px solid transparent;
}

.van-popup--center {
  border-radius: 30px;
}

.list .item {
  padding: 20px;
  border-bottom: 1px solid #eee;
}
</style>
